// extracted by mini-css-extract-plugin
export default {"root":"style_root__Jd0dE","data":"style_data__cRoiX","address":"style_address__R29eH","submit":"style_submit__KxBYR"};